import palette from '@lib/core/src/theme/palette';
import { Box, Button, Stack, styled, Typography } from '@mui/material';

export const EmailScopeButton = styled(Button, { shouldForwardProp: prop => prop !== 'isActive' })<{
  isActive: boolean;
}>(({ isActive }) => ({
  backgroundColor: palette.white,
  color: isActive ? palette.black : palette.grey[500],
  border: `${isActive ? 1.5 : 1}px solid ${isActive ? palette.grey[500] : palette.grey[1200]}`,
  borderRadius: '8px',
  padding: '16px 12px',
  fontSize: '12px',
  justifyContent: 'flex-start',
  flex: 1,
  fontWeight: 500,
  textTransform: 'none'
}));

export const EmailCriteriaContainer = styled(Stack)(() => ({
  flexDirection: 'row',
  border: `1px solid ${palette.grey[1200]}`,
  gap: '12px',
  borderRadius: '8px',
  background: palette.white,
  alignItems: 'center',
  padding: '12px'
}));

export const EmailConfigTitle = styled(Typography)({
  color: palette.grey[500],
  fontSize: '11px',
  marginBottom: '6px'
});

export const SelectTimeframeButton = styled(Button)({
  borderRadius: '88px',
  padding: '2px 8px',
  border: `1px solid ${palette.grey[1200]}`,
  boxShadow: 'none',
  backgroundColor: 'transparent',
  color: palette.black,
  fontSize: '12px',
  marginRight: '8px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: 'transparent',
    boxShadow: 'none'
  },
  '&.Mui-disabled': {
    backgroundColor: 'transparent'
  }
});
export const TimeframeOption = styled(Box)({
  padding: '5px 8px',
  minWidth: '80px',
  '&:hover': {
    backgroundColor: palette.grey[1200]
  }
});
